import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from 'src/app/modules/shared/shared.module';
import { HttpErrorInterceptor } from 'src/app/modules/core/helpers/http-error.interceptor';
import { DistributorRoutingModule } from 'src/app/modules/distributor/distributor-routing.module';
import { DistributorLoginComponent } from './distributor-login/distributor-login.component';
import { CouponListComponent } from './coupon/coupon-list/coupon-list.component';
import { CouponReportComponent } from './reports/coupon-report/coupon-report.component';
//import { PaymentsComponent } from 'src/app/modules/cpg/payments/payments.component';

import { PageFiltersComponent } from 'src/app/modules/distributor/components/page-filters/page-filters.component';
import { PaymentsComponent } from './payments/payments.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

@NgModule({
  declarations: [
    DistributorLoginComponent,
    CouponListComponent,
    CouponReportComponent,
    //PaymentsComponent,

    PageFiltersComponent,
    PaymentsComponent,
    ChangePasswordComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DistributorRoutingModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  exports: [],
})
export class DistributorModule { }